var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Header',{attrs:{"title":"Úprava odběrného místa"},scopedSlots:_vm._u([{key:"buttons",fn:function(){return [_c('BackLinkButton',{attrs:{"to":{name: 'supply_point_show'}}})]},proxy:true}])}),_c('SupplyPointForm',{attrs:{"request":_vm.request,"is-processing":_vm.isProcessing},on:{"submitted":_vm.onSubmitted}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }